"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTbd = exports.getDate = exports.getSpan = void 0;
var date_fns_tz_1 = require("date-fns-tz");
var date_fns_1 = require("date-fns");
var defaultSpanFormat = { scheduled: "eee, MMM d, yyyy", windowed: "eee, MMM d, yyyy" };
function getSpan(dateData, customFormat) {
    var _a;
    var startTime = dateData.startTime, endTime = dateData.endTime, timezone = dateData.timezone, windowEndTime = dateData.windowEndTime, windowStartTime = dateData.windowStartTime;
    var dateFormat = __assign(__assign({}, defaultSpanFormat), customFormat);
    if (!timezone)
        return "";
    var span = "";
    if (!startTime && windowStartTime) {
        var start = (0, date_fns_tz_1.utcToZonedTime)(windowStartTime, timezone);
        if (windowEndTime) {
            var end = (0, date_fns_tz_1.utcToZonedTime)(windowEndTime, timezone);
            var formattedStart = (0, date_fns_tz_1.format)(start, dateFormat.windowed);
            var formattedEnd = (0, date_fns_tz_1.format)(end, dateFormat.windowed);
            if (formattedStart === formattedEnd)
                return "";
            span = "".concat(formattedStart, " - ").concat(formattedEnd);
        }
    }
    else {
        var start = (0, date_fns_tz_1.utcToZonedTime)(startTime, timezone);
        var end = endTime
            ? " - " + (0, date_fns_tz_1.format)((0, date_fns_tz_1.utcToZonedTime)(endTime, timezone), (_a = dateFormat.scheduledEnd) !== null && _a !== void 0 ? _a : dateFormat.scheduled)
            : "";
        span = "".concat((0, date_fns_tz_1.format)(start, dateFormat.scheduled)).concat(end);
    }
    return span;
}
exports.getSpan = getSpan;
var defaultDateFormat = { scheduled: "h:mma", windowed: "MM/dd/yy" };
function getDate(dateData, customFormat) {
    var startTime = dateData.startTime, timezone = dateData.timezone, windowEndTime = dateData.windowEndTime, windowStartTime = dateData.windowStartTime;
    var dateFormat = __assign(__assign({}, defaultDateFormat), customFormat);
    if (!timezone)
        return "";
    var date = "";
    if (!startTime && windowStartTime) {
        var start = (0, date_fns_tz_1.utcToZonedTime)(windowStartTime, timezone);
        if (windowEndTime) {
            var end = (0, date_fns_tz_1.utcToZonedTime)(windowEndTime, timezone);
            if ((0, date_fns_1.isSameDay)(start, end)) {
                date = (0, date_fns_tz_1.format)(start, dateFormat.scheduled);
            }
            else {
                date = "By " + (0, date_fns_tz_1.format)(end, dateFormat.windowed);
            }
        }
        else {
            date = "From " + (0, date_fns_tz_1.format)(start, dateFormat.windowed);
        }
    }
    else {
        var start = (0, date_fns_tz_1.utcToZonedTime)(startTime, timezone);
        date = (0, date_fns_tz_1.format)(start, dateFormat.scheduled);
    }
    return date;
}
exports.getDate = getDate;
function isTbd(dateData) {
    return (dateData.windowLocalEndTime &&
        dateData.windowLocalStartTime &&
        dateData.timezone &&
        (0, date_fns_tz_1.format)((0, date_fns_tz_1.utcToZonedTime)(dateData.windowLocalEndTime, dateData.timezone), "yyyymmdd") ===
            (0, date_fns_tz_1.format)((0, date_fns_tz_1.utcToZonedTime)(dateData.windowLocalStartTime, dateData.timezone), "yyyymmdd"));
}
exports.isTbd = isTbd;
